import { ErrorCode } from '@app/models/error';

import { IResultFormValues } from './interfaces';

export const LAYOUT = {
  labelCol: { span: 5 },
  wrapperCol: { span: 17 },
};

export const TAIL_LAYOUT = {
  wrapperCol: { xs: { span: 24 }, sm: { offset: 5, span: 17 } },
};

export const INITIAL_FORM_VALUES: IResultFormValues = {
  name: '',
  surname: '',
  email: '',
  first_pwd: '',
  second_pwd: '',
  sector: '',
  jobtitle: '',
  company_name: '',
  inn: '',
  worker_count: '1',
};

export const INN_ERROR_CODES: ReadonlyArray<ErrorCode> = [
  ErrorCode.INVALID_INN,
  ErrorCode.PARTY_NOT_FOUND,
  ErrorCode.PARTY_NOT_ACTIVE,
];

export const INN_ERROR_POINTER = '/inn';
export const INN_STEP = 5;
